<template>
  <div class="card">
    <div class="card-header">
      <i class="icon-globe"></i> Statistiques et classement
      <i
        class="fa fa-info-circle ml-05"
        v-tooltip="{
          content:
            'Sont exclue des stats les séances découvertes, les events, les commandes ayant pour commercial “Marchés Publics”, les commandes B2B et les commandes “autres”.',
          placement: 'top',
        }"
      ></i>
    </div>
    <div class="card-block">
      <div class="row">
        <div class="col">
          <CoachStats
            :stats="coach.coach.stats"
            v-if="coach && coach.coach && coach.coach.stats"
          />
          <div v-else>Aucune donnée de statistique</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoachStats from "@/components/coach/CoachStats";

export default {
  components: {
    CoachStats,
  },
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
};
</script>
